var map = {
	"./be-dark.png": 24,
	"./be-light.png": 25,
	"./cancel.png": 63,
	"./fb-dark.png": 20,
	"./fb-light.png": 21,
	"./global-bg-2x.png": 29,
	"./icon-menu-2x.png": 26,
	"./ig-dark.png": 22,
	"./ig-light.png": 23,
	"./local-k-dark.png": 30,
	"./local-k-light.png": 31,
	"./logo-global-2x.png": 64,
	"./logo-k-1x.png": 8,
	"./logo-k-2x.png": 27,
	"./logo-kg-2x.png": 28,
	"./messages.png": 65,
	"./phone.png": 32,
	"./service-comp.png": 66,
	"./service-mob.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;